import React from "react";

import { Button } from "../../../../Shared/Buttons/Button";
import { dmnIdentity } from "../../../../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../../../../utils/environment";
import dayjs from "dayjs";
import { useDiaryContext } from "../../../../../hooks/useDiaryContext";
import { ToggleButton } from "../../../../Shared/Buttons/ToggleButton";
import { document } from "@workspace/mobile";
import { DownloadType } from "../DownloadPrintModal";
import {
  errorHandler,
  apiFetchNotOkHandler
} from "../../../../../APIs/errorHandler";
/**
 * DownloadRunSheetContent Props
 */
type DownloadRunSheetContentProps = {
  onClose?: () => void;
  onBack?: () => void;
  onSelectDownloadType?: (type: DownloadType) => void;
};

/**
 * DownloadRunSheetContent Modal
 *
 * @param param0
 * @returns
 */
export const DownloadRunSheetContent = ({
  onBack,
  onClose,
  onSelectDownloadType
}: DownloadRunSheetContentProps) => {
  const { venueConfig, date } = useDiaryContext();
  const [fileType, setFileType] = React.useState<string>("pdf");

  const handleSelectCustomRunSheet = () => {
    onSelectDownloadType?.("CustomRunSheet");
  };

  const handleBack = () => {
    onBack?.();
  };

  const handleDownload = async () => {
    const token = await dmnIdentity.getAccessToken();
    const environmentVars = getEnvironmentProps(token);
    const venueId = venueConfig?._id;
    const formattedDate = dayjs(date).format("YYYY-MM-DD");

    const url = new URL(
      `${environmentVars?.COLLINS_API_BASE_URL}/run-sheets/short/${venueId}/${formattedDate}`
    );
    url.searchParams.set("output", fileType);
    url.searchParams.set("status", "in_progress,complete");

    try {
      const request = await fetch(`${url}`, {
        headers: {
          authorization: `Bearer ${token}`
        },
        method: "GET"
      });
      if (!request.ok) {
        apiFetchNotOkHandler(request, "Error downloading run sheet");
        return;
      }

      const arrBuffer = await request.arrayBuffer();
      const file = new Blob([arrBuffer], { type: "application/pdf" });
      const fileReader = new FileReader();
      fileReader.onloadend = async () => {
        const result = fileReader.result as string;
        const [, mimeType, , data] = result.split(/[:;,]+/);
        const fileName = "run-sheet.csv";
        document.open({ mimeType, data, fileName });
      };

      fileReader.readAsDataURL(file);
    } catch (error) {
      errorHandler(error, "Error downloading run sheet");

      return;
    }
    onClose?.();
  };

  return (
    <div className="DownloadFileCotainer flex flex-col flex-1">
      <div className="DownloadFileContent flex-1 flex flex-col">
        <p>Run Sheet</p>
        <div>
          <strong>Sheet kind</strong>
        </div>
        <div>
          <div className="InlineTabsWrapper InlineTabsWrapperStart">
            <ToggleButton
              text1="Short run sheet"
              text2="Custom run sheet"
              selected={true}
              onClick={handleSelectCustomRunSheet}
            />
          </div>
        </div>
        <div>
          <strong>File type</strong>
        </div>
        <div>
          <div className="InlineTabsWrapper InlineTabsWrapperStart">
            <ToggleButton
              text1="PDF"
              text2="Excel/CSV"
              selected={fileType === "pdf"}
              onClick={() => {
                setFileType(fileType === "pdf" ? "csv" : "pdf");
              }}
            />
          </div>
        </div>
      </div>
      <div className="DownloadFileFooter flex-none flex flex-row gap-2.5">
        <Button className="DownloadFileFooterButton" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="DownloadFileFooterButton"
          onClick={handleDownload}
          type="primary"
        >
          Download Run Sheet
        </Button>
      </div>
    </div>
  );
};
